import {useParams, useRouteMatch} from 'react-router-dom';
import {DeviceForm} from '../../../../../../../components/device-form/device-form';
import {CaregiverMode} from '../../../../../../../enums';

export default function DeviceDetailsProfessionalCaregiverOfficeScreen({
  canWrite,
}: {
  canWrite: boolean;
}) {
  // Get params
  let {id, deviceId}: {id?: string; deviceId?: string} = useParams();
  const currentDeviceId = deviceId || id;

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  // Only professional caregivers that are managers or administrators can edit devices.
  // All other professional caregivers can only view the device.
  return (
    <DeviceForm
      caregiverMode={CaregiverMode.Professional}
      canWrite={canWrite}
      showPageTitle={false}
      redirectUrl={currentDeviceId ? `${url.replace(`/${currentDeviceId}`, '')}` : url}
    />
  );
}
